__turbopack_context__.v({
  "articleHead": "WhitePaper-module__bqbikW__articleHead",
  "boldText": "WhitePaper-module__bqbikW__boldText",
  "contactWrapper": "WhitePaper-module__bqbikW__contactWrapper",
  "description": "WhitePaper-module__bqbikW__description",
  "divider": "WhitePaper-module__bqbikW__divider",
  "iframe": "WhitePaper-module__bqbikW__iframe",
  "image": "WhitePaper-module__bqbikW__image",
  "largeText": "WhitePaper-module__bqbikW__largeText",
  "leftPanel": "WhitePaper-module__bqbikW__leftPanel",
  "line": "WhitePaper-module__bqbikW__line",
  "mediaWrapper": "WhitePaper-module__bqbikW__mediaWrapper",
  "moduleWrapper": "WhitePaper-module__bqbikW__moduleWrapper",
  "normalText": "WhitePaper-module__bqbikW__normalText",
  "outerWrapper": "WhitePaper-module__bqbikW__outerWrapper",
  "readingLine": "WhitePaper-module__bqbikW__readingLine",
  "rightPanel": "WhitePaper-module__bqbikW__rightPanel",
  "root": "WhitePaper-module__bqbikW__root",
  "socialWrapper": "WhitePaper-module__bqbikW__socialWrapper",
  "taxonomy": "WhitePaper-module__bqbikW__taxonomy",
  "taxonomyItem": "WhitePaper-module__bqbikW__taxonomyItem",
  "taxonomyList": "WhitePaper-module__bqbikW__taxonomyList",
  "taxonomyWrapper": "WhitePaper-module__bqbikW__taxonomyWrapper",
  "virtualTour": "WhitePaper-module__bqbikW__virtualTour",
});
